import { gql } from '@grandvisionhq/graphql';

const failures = gql`
  fragment FailureMessage on AppointmentFailure {
    message
  }
`;

export { failures };
//# sourceMappingURL=failures.js.map
